 <!--   attendances TABLE Column absence definition
             0 : no absence
             1 : absence
             2 : late
             3 : leave early
 -->

<template>

<div class="app-container">

 
<div v-show = "!dialogHistory" > 

<el-row>
  <el-col :span="20" class = "bigbolds"  ><div class="grid-content bg-purple-light" style=" text-align:center" >{{displayTitle}}</div></el-col>
  <el-col :span="20" class = "bigbolds"  ><div class="grid-content bg-purple-light" style=" text-align:center" >{{displayCTitle}}</div></el-col>
</el-row>
<el-row>
  <el-col :span="3"><div class="grid-content bg-purple"></div></el-col>
  <el-col :span="14" class = "bolds" ><div class="grid-content bg-purple-light" style=" text-align:center">{{displaySchoolDate}}</div></el-col>
  <el-col :span="3"><div class="grid-content bg-purple"></div></el-col>
</el-row>
</div>

 <!-- <el-button   style='margin-left:20px;float:left'  type="primary" @click="SetupEmail()">Setup Email</el-button>  -->


 <div v-show ="attendActive" > 

<el-button  type="info" style='margin-left:20px;float:left'   @click="getClasses" > Back to Classes </el-button> 
<el-button   v-if="curClassDateActive" type="info"  @click="subAttendance" > Submit {{newAttend}} Attendance Sheet </el-button> 
<br>
<br>


<el-table :data="classAttend" border style="width: 100%" fit max-height="800">


  <el-table-column :label="displayInfo"  >
     <el-table-column  type='index'  width="60">
       </el-table-column>

    <el-table-column  label="Students" width="200">
            <template scope="scope">
        <span class = "bolds" style="margin-left: 10px"  >{{scope.row.student_name }} </span>
           </template>
     </el-table-column>
 
     <el-table-column  label="(學/学)生中文名字" width="200">
            <template scope="scope">

        <span  class="link-type" @click="goEditStudentCName(scope.row)" style="margin-left: 10px">{{scope.row.chinese_name }} </span>
      <span  class="link-small" @click="goEditStudentCName(scope.row)"  v-if="scope.row.chinese_name == '' " style="margin-left: 10px">我的中文名字是? </span>
        <p v-if="scope.row.notcname" ></p>        
        <span v-if="scope.row.notcname" class = "notcname" style="margin-left: 10px">像英文發音/寫中文名 </span>
           </template>
     </el-table-column>

 
 
     <el-table-column v-if="curClassDateActive" :label="displayAttended" width="100">        
            <template scope="scope">
          <el-button v-if="scope.row.absence == 0" size="small" type="success"> Present </el-button>
          <el-button v-if="scope.row.absence != 0" size="small"  @click="changeStatus(scope.$index,scope.row, 0)">  </el-button>
           </template>
       </el-table-column>

     <el-table-column  v-if="curClassDateActive" :label="displayAbsence" width="100">        
            <template scope="scope">
          <el-button v-if="scope.row.absence != 1" size="small"  @click="changeStatus(scope.$index,scope.row, 1)">  </el-button>
          <el-button v-if="scope.row.absence == 1" size="small" type="danger"> Absent </el-button>
           </template>
       </el-table-column>

     <el-table-column  v-if="curClassDateActive" :label="displayLate" width="80">        
           <template scope="scope">
          <el-button v-if="scope.row.absence == 2" size="small" type="danger" > Late </el-button>
          <el-button v-if="scope.row.absence !== 2" size="small" @click="changeStatus(scope.$index,scope.row, 2 )">  </el-button>
           </template>
       </el-table-column>
     <el-table-column  v-if="curClassDateActive" :label="displayLeft" width="80">        
           <template scope="scope">
         <el-button v-if="scope.row.absence == 3" size="small" type="danger" > Left </el-button>
         <el-button v-if="scope.row.absence !== 3" size="small" @click="changeStatus(scope.$index, scope.row, 3 )">  </el-button>
          </template>
       </el-table-column>

   </el-table-column>
    

</el-table>

 </div>
<div v-show ="!attendActive &&  !dialogHistory" > 

  <el-table :data="teacherClassesArr"  max-height="800" border style=" margin-left: 20px" :row-class-name="tableRowClassName"  >



   <el-table-column label="Classes" prop="fullclass"  sortable width="150">
 <!--           <template scope="scope">
              <span class="link-type" @click="goUpdateClass(scope.row)"> {{scope.row.fullclass}}</span>                  
           </template> -->
    </el-table-column>
   <el-table-column label="Title" prop="title"  width="300"> </el-table-column>
   <!-- <el-table-column label="Chinese Title" prop="chinese_title"  width="250"> </el-table-column> -->

      <el-table-column prop="classroom" label="Classroom " width="120" >
  
      </el-table-column>   

       <el-table-column align ="center" label="Take Attendance or 添加或修改中文名 " width="170"> 
      <template scope="scope">
        <el-button   type="info" class="el-icon-circle-check" @click="getAttendance(scope.row)" > </el-button> 
      </template>  
      </el-table-column> 
      
      <el-table-column align ="center"  label="Attendance History " width="120">
      <template scope="scope">
        <el-button  type="info" class="el-icon-circle-check" @click="getHistory(scope.row)" > </el-button> 
      </template>  
      </el-table-column> 

      <el-table-column align ="center"  label="Class List " width="120">
      <template scope="scope">
        <el-button  type="info" class="el-icon-circle-check" @click="detailClass(scope.row)" > </el-button> 
      </template>  
      </el-table-column> 
      
       </el-table>
 </div>
 


<div v-show ="dialogHistory" > 

<el-row>
  <el-col :span="20" class = "bolds"  ><div class="grid-content bg-purple-light" style=" text-align:center" >{{DialogInfo}}</div></el-col>
</el-row>

 <el-button   style='margin-bottom:10px;margin-left:30px;float:left'  type="primary" @click="doneHistory()">Back</el-button> 
<br>
<br>
 <el-row>
 <el-col :span="20" class = "bolds"  ><div class="grid-content bg-purple-light" style=" text-align:center" >
     <span class="bolds"> Show Certain Months ::: Begin Month </span>
  <el-date-picker @change="dateBegin" v-model="monthB" type="month" placeholder="Pick begin month">
  </el-date-picker>

  <span class="bolds">   End Month</span>
  <el-date-picker @change="dateEnd" v-model="monthE" type="month" placeholder="Pick End month">
  </el-date-picker>
  </div></el-col>
  </el-row>

<br>

<el-table :data="attendHistory"  max-height="800" @cell-click="getOneHist" border style="width: 100%"  >
  
    <el-table-column fixed type='index'  width="60">
       </el-table-column>

  
     <el-table-column fixed label="Students" width="200">
            <template scope="scope">
        <span class = "bolds" style="margin-left: 10px">{{scope.row.student_name }} </span>
           </template>
     </el-table-column>

<el-table-column   :key="col.prop"  v-for="col in disCols" :prop="col.prop" :label="col.label" :width="col.width" :formatter="formatCell"  >
  
</el-table-column> 
  </el-table> 
 </div>
 

  <!-- Display only detailed class attendance -->

 <el-dialog :title="DialogInfo" :show-close=false :visible.sync="dialogOneHist" size="full"> 

  <el-button   style='margin-bottom:20px;float:left'  type="primary" @click="DoneOneHist()">Back</el-button> 

<!-- <el-button   style='margin-left:20px;float:left'  type="primary" @click="PreviewEmail()">Preview Email</el-button>  -->

 <el-button   style='margin-left:20px;float:left'  type="primary" @click="AttendanceEmail()">Send Attendance Email</el-button> 

<el-table :data="classAttend"  max-height="800" border style="width: 100%"
   ref="multipleTable" @selection-change="handleSelectionChange" >

<!--     @selection-change="handleSelectionChange"  @select="handleSelect"
<el-table-column v-for="col in cols" :prop="col.prop" :label="col.label" :width="col.width" >
  
</el-table-column> -->

  <el-table-column :label="displayInfo"  >
     <el-table-column  type='index'  width="60">
       </el-table-column>
 
     <el-table-column  label="Students" width="200">
            <template scope="scope">
        <span class = "bolds" style="margin-left: 10px"  >{{scope.row.student_name }} </span>
           </template>
     </el-table-column>

 
     <el-table-column :label="displayAttended" width="100">        
            <template scope="scope">
          <el-button v-if="scope.row.absence == 0" size="small" type="success"> Present </el-button>
          <el-button v-if="scope.row.absence != 0" size="small" >  </el-button>
<!--          <el-button v-if="scope.row.absence == 3" size="small" > Leave</el-button> -->
           </template>
       </el-table-column>

     <el-table-column :label="displayAbsence" width="100">        
            <template scope="scope">
 <!-- <el-button v-if="scope.row.absence != 0  && scope.row.absence != 1  "  size="small" > </el-button>  -->
          <el-button v-if="scope.row.absence != 1" size="small" >  </el-button>
          <el-button v-if="scope.row.absence == 1" size="small" type="danger"> Absent </el-button>
<!--          <el-button v-if="scope.row.absence == 3" size="small" > Leave</el-button> -->
           </template>
       </el-table-column>

     <el-table-column :label="displayLate" width="80">        
           <template scope="scope">
          </el-button>
          <el-button v-if="scope.row.absence == 2" size="small" type="danger" > Late </el-button>
          <el-button v-if="scope.row.absence !== 2" size="small">  </el-button>
           </template>
       </el-table-column>
     <el-table-column :label="displayLeft" width="80">        
           <template scope="scope">
       
         <el-button v-if="scope.row.absence == 3" size="small" type="danger" > Left </el-button>
         <el-button v-if="scope.row.absence !== 3" size="small">  </el-button>
          </template>
       </el-table-column>
     <el-table-column label="Email Absent Students" width="200">        
           <template scope="scope">
       
         <span v-if="scope.row.absence == 1" size="small">  {{scope.row.email}} </span>
         <!-- <el-button v-if="scope.row.absence !== 3" size="small">  </el-button> -->
          </template>
       </el-table-column>

       <el-table-column type="selection" width="55">
           
   </el-table-column>


   </el-table-column>
    

</el-table>

 </el-dialog>

 <!--******** setup  Teacher email form dialog*********-->


<el-dialog title= "Setup Email" size ="full" :show-close=false :visible.sync="dialogTeacherForm">
  <el-table :data="teacher_InputArr"  style="width: 100%">
    
    <el-table-column>   
       <template scope="scope">
    <el-form label-position="left">
<!--     <el-form-item label="First Name" :label-width="formLabelWidth">
      <el-input v-model="teacher_Input.teacher_fname" auto-complete="off"></el-input>
    </el-form-item>
    <el-form-item label="Last Name" :label-width="formLabelWidth">
      <el-input v-model="teacher_Input.teacher_lname" auto-complete="off"></el-input>
    </el-form-item>    
    <el-form-item label="Chinese Name" :label-width="formLabelWidth">
      <el-input v-model="teacher_Input.teacher_cname" auto-complete="off"></el-input>
    </el-form-item> -->

    <el-form-item label="Reply to (Email):" :label-width="formLabelWidth">
      <!-- <el-input v-model="teacher_Input.email" auto-complete="off"></el-input> -->
            <span>{{ scope.row.email }}</span>
    </el-form-item>
<!-- 
  <el-form-item label="Phone :" :label-width="formLabelWidth">
      <el-input v-model="teacher_Input.phone" auto-complete="off"></el-input>
    </el-form-item>
 -->

   <el-form-item label="Subject :" :label-width="formLabelWidth">
            <span>{{ scope.row.subject }}</span>
      <!-- <el-input v-model="teacher_Input.subject" auto-complete="off"></el-input> -->
    </el-form-item>

<!-- 
    <el-form-item label="Email 2" :label-width="formLabelWidth">
      <el-input v-model="teacher_Input.email2" auto-complete="off"></el-input>
    </el-form-item>
 -->
 
    <el-form-item label="Message (Body)" :label-width="formLabelWidth">
            <span>{{ scope.row.message }}</span>
      <!-- <el-input  type="textarea" v-model="teacher_Input.message" auto-complete="off"></el-input> -->
    </el-form-item>
    
  </el-form>
     </template>
          </el-table-column>   

    </el-table>

  <span slot="footer" class="dialog-footer">
    <el-button @click="EditTeacherCancel">Cancel</el-button>
    <el-button type="primary" @click="EditTeacher()">Confirm</el-button>
  </span>

</el-dialog>

<!--******** Edit Student chinese name form dialog*********-->

<el-dialog title="Edit Student Chinese Name (添加或修改中文名)"  :show-close=false :visible.sync="dialogStudentForm">
  <el-form :model="getrow">
    <el-form-item label="中文名" :label-width="formLabelWidth">
      <el-input v-model="getrow.chinese_name" auto-complete="off"></el-input>
    </el-form-item>
 </el-form>
  <span slot="footer" class="dialog-footer">
    <el-button @click="EditStudentCancel">Cancel</el-button>
    <el-button type="primary" @click="EditStudent()">Confirm</el-button>
  </span>
</el-dialog>




<el-dialog :title="DialogInfo" :show-close=false :visible.sync="dialogClassCode" size="full">
          <el-button   style='margin-bottom:20px;float:left'  type="primary" @click="DoneDialogClassCode()">Back</el-button> 

         

    <el-button style='margin-bottom:20px;float:right' type="primary" icon="document" @click="handleDownload('')">EC list Excel</el-button>
    <el-button style='margin-bottom:20px;float:right' type="primary" icon="document" @click="handleDownload('pdf')">EC list PDF</el-button>
    <el-button style='margin-bottom:20px;float:right' type="primary" icon="document" @click="handleDownload('cp')">For Simple Class Parent Excel</el-button>

 <!--      Display Class code  with students  -->

  <el-table :data="classAttendArr" border style="width: 100%">
<!-- 
    <el-table-column label="Date & Time" width="180">
      <template scope="scope">
        <span style="margin-left: 10px">{{ scope.row.created | formatDate }}</span>
      </template>
    </el-table-column>
 -->
        <el-table-column  type='index'  width="60">
       </el-table-column>
  
 <!--     <el-table-column label="Class Code" width="140">
      <template scope="scope">
        <span >{{ scope.row.class_code}} </span>
      </template>
      </el-table-column>
 --> 

     <el-table-column label="Date" prop="created"  sortable width="180">
      <template scope="scope">
        <span >{{ scope.row.created | formatDate }} </span>
      </template>
      </el-table-column>


    <el-table-column label="Students" prop="last_name"  sortable width="150">
           <template scope="scope">
          
             <span> {{scope.row.student_name}}</span>                  
           </template>
  
    </el-table-column>

    <el-table-column prop="chinese_name" label="中文名 " width="120" >
  
      </el-table-column> 

  <!-- <div v-show = "allergyOn" >  -->
    <!-- </div> -->


    <el-table-column label="Parents"  prop="father_lname"  sortable  width="150">
      <template scope="scope">
       <!-- <span class="link-type" @click="SelFamily(scope.row)">{{scope.row.father_fname}} {{scope.row.father_lname}}</span>                   -->
        
        <span style="margin-left: 10px">{{ scope.row.father_fname }} {{ scope.row.father_lname }}</span>
      </template>
    </el-table-column>

    <el-table-column label="Parents2"    width="150">
      <template scope="scope">
       <span >{{scope.row.parent2}}</span>                  
        
      </template>
    </el-table-column>

  <el-table-column label="Email" width="250">
      <template scope="scope">
        <span style="margin-left: 10px">{{ scope.row.email }} </span>
      </template>
      </el-table-column>

      <el-table-column label="Phone" width="140">
      <template scope="scope">
        <span >{{ scope.row.phone | phone }} </span>
      </template>
      </el-table-column>

 <!-- 
     <el-table-column label="Class Title" prop="title" sortable width="250">
      <template scope="scope">
        <span style="margin-left: 10px">{{ scope.row.title }} </span>
      </template>
      </el-table-column>

 -->
     <el-table-column label="EC Person" width="180">
      <template scope="scope">
        <span style="margin-left: 10px">{{ scope.row.ecp_name }} </span>
      </template>    
      </el-table-column>

      <el-table-column label="Medical Condition" width="180">
      <template scope="scope">
        <span style="margin-left: 10px">{{ scope.row.medical_cond }} </span>
      </template>

      </el-table-column>
      <el-table-column label="Allergy" width="180">
      <template scope="scope">
        <span style="margin-left: 10px">{{ scope.row.allergy }} </span>
      </template>

      </el-table-column>
      <el-table-column label="Dr. Name" width="180">
      <template scope="scope">
        <span style="margin-left: 10px">{{ scope.row.doctor_name }} </span>
      </template>

      </el-table-column>
      <el-table-column label="Dr. Phone" width="180">
      <template scope="scope">
        <span style="margin-left: 10px">{{ scope.row.doctor_phone }} </span>
      </template>
      </el-table-column>

    </el-table-column>
      <el-table-column label="Medical Insurance" width="180">
      <template scope="scope">
        <span style="margin-left: 10px">{{ scope.row.ins_company }} </span>
      </template>
      </el-table-column>
    </el-table-column>
      <el-table-column label="Insurance #" width="180">
      <template scope="scope">
        <span style="margin-left: 10px">{{ scope.row.ins_policy }} </span>
      </template>
      </el-table-column>

     
   </el-table>
 </el-dialog>

 </div>

   
</template>

<script>
    // ajax 使用官方推荐的 axios
    import axios from 'axios';
    import auth from '../auth'
    import moment from 'moment';
    var pako = require('pako');

     var jsPDF = require('jspdf');
     require ('jspdf-autotable');

//const this.$API_url = 'http://192.168.1.109:8090';
   // :formatter="col.formatCell" :key="col.prop"
   
    export default{
        data () {
          
            return{
          legacySystemHTML:'',
          teacher_id: auth.teacher.teacher_id,
          token_time: auth.teacher.token_time,
          teacher_name: auth.teacher.teacher_name,
          teacher_info: auth.teacher.teacher_info,
          teacher: auth.teacher,

          isArticleVisible:false,
            DialogInfo:'',
            dialogClassCode:false,
            displaySchoolDate:'',
            dialogHistory:false,
            dialogOneHist:false,
            dialogTeacherForm:false,
            attendHistory:[],
            subDate:[],
            curClassDate:'',
            nextClassDate:'',
            absenceDate:'',
            curClassDateActive:false,
            curClassId:0,
            curClassName:'',
            curAbsenceCnt:0,
            curLateCnt:0,
            curLeftCnt:0,
            curAttendCnt:0,
            newAttend:'',
            addTeacher:'Edit Teacher Info',
            addTeacherTrue:false,
            selYear_holder:'',
            multipleSelection: [],
            teacher_Input:{},
            teacher_InputArr:[],
            junkeMail:[{email:'suejerryk@yahoo.com'},{email:'khuynh_99@yahoo.com'},{email:'kaitlindang@gmail.com'},{email:'meghandang12@gmail.com'}],

            
            formLabelWidth: '250px',
            getrow: {},
            getDetail:{},
            checkList:['Absence','Leave'],
            tmpArr:[],
            attendActive:false,
           
         mapMonth: [],

          cols : [],
          disCols:[],
            volunteerCatVal:'',
            volunteerCodeVal:'',
            selYear:'',
    
              monthBegin: '',
              monthEnd: '',
              monthB: '',
              monthE: '',


            teacherArr:[],
            teacherClassesArr:[],
                  filter: '',
selectedOptions:[],
        classOptions:[],
               classOptions1:[{
          children:[{}]
        }],
         // options
              formInline: {
                firstname: 'john',
                lastname: 'chan'
              },
                search: '',
                loading: false,
                dialogStudentForm:false,
                listArr: [],
                classList:[],
                teacherList:[],
                PayStudentClass:[],
                classArr : [],                
                displayInfo:'',
                displayTitle:'',
                displayAbsence:'ewew',
                displayAttended:' att',
                displayLate:'late',
                displayLeft:'eww',
                classroom_Input:{},
                teacher_Input:{},
                class_Input:{},
                thisTeacher:'',
                teacherAssign: {teacher:'',class:'',existing:'Dog xxx'},
                filterCat:[],
                getAttendAbsence:[],
                prevClassAttend:[],
                tmptmp:[],
                attendDatesArr:[],
                classAttendArr:[],
                classAttend:[],
                time1:'',
                displayCTitle:'',
                familyVolun:[]
            }
        },
     created () {
       var today = new Date();
       //  this.selYear = today.getFullYear(); 

       // Need to update year manually every year.
         this.selYear = 2026; 
         this.displayTitle = 'Year: ' +  this.selYear + ' - Welcome Teacher ' + this.teacher_name;
         this.displayCTitle =  this.teacher_info.teacher_cname +'老(師/师)好' ;

    /*         this.teacher_Input = { teacher_lname: this.teacher_info.teacher_lname , teacher_fname: this.teacher_info.teacher_fname ,
            teacher_cname: this.teacher_info.teacher_cname, email: this.teacher_info.email, phone:this.teacher_info.phone,
            subject: '', message: 'Attendance Message'};   
     */        
            

         this.loadList();
     //    this.curClassDate = '2017-09-23';
      },
   
        filters: {
       phone (phone) {
               return phone.replace(/[^0-9]/g, '')
                .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
              },
  formatDate (value) {
       if (value) {
          return moment(String(value)).format('MM/DD/YYYY hh:mm a')
     }
}
       
          
  
    },
    
 methods: {
// GD: 8/22/2026: fixed space check error
 
 titleCase(str) {
        //  return str.toLowerCase().split(' ').map(function(word) {
        //   return word.replace(word[0], word[0].toUpperCase());  }).join(' ');
        return str.toLowerCase().split(/\s+/).map(function(word) {
  return word ? word.replace(word[0], word[0].toUpperCase()) : '';
}).join(' ');
       }, 
// check for token time, then log user out .
checkTimeOut() {
 // console.log('token_time' , this.token_time);

 var date1= new Date().getTime(); 
 var delta = (date1 - this.token_time)/3600/1000;    // hours

// if (delta > 0.02) {        // 100 seconds
 if (delta > 9.00) {        //  9 hours
  // console.log('time diff', delta);
        this.$message({
          showClose: true,
          message: 'Login Session Expired!! Please Login Again!',
          type: 'warning',
          duration: 5000,           
        });     
 
      setTimeout(()=>{    this.logout() },5000);
 
 } 


},
logout() {

     auth.logout();
     window.location.reload(true); // logout complete reload login from server. basically start from scratch, lose all user data info.
     this.$router.push({path: '/teacher'});    // physical url must be  /teacher to match exact name.

},


getClasses(){

this.attendActive = false;

},
 EditStudentCancel() {
                 this.dialogStudentForm = false;

},
goEditStudentCName(row) {
//console.log('student', row);
  this.getrow = row;
  this.dialogStudentForm = true;


 },
   
    dateBegin(val) {
     // console.log('dog begin', val, this.cols);
      this.monthBegin = val;
      this.monthE ='';
    },
     dateEnd(val) {
      var tmpdate;
      var tbegin =  this.monthBegin.split("-");
      var tend = val.split("-");
      this.disCols =[];
  // console.log('dog end', tbegin, 'tend', tend);
   if(this.monthBegin != ''  ) {
     for (var i = this.cols.length-1; i >= 0; i--)  { 
         tmpdate = this.cols[i].prop.split("-");
                 if ( (tmpdate[0] >= tbegin[0] && tmpdate[1] >= tbegin[1]) &&
              (tend[0] > tmpdate[0] || (tend[0] >= tmpdate[0] && tend[1] >= tmpdate[1]) ))   {
           this.disCols.push(this.cols[i]);    
           }
     }
    }

    },

EditStudent() {
     var   _this = this;
                 this.dialogStudentForm = false;
                 var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
var localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0,-1).substring(0, 19).replace('T', ' ');

  var inputs = {chinese_name:this.getrow.chinese_name, modified:localISOTime}
    if (this.getrow.chinese_name != '' ) {
       axios.put (this.$API_url +'/student_cname/' + this.getrow.student_id ,  inputs, { headers: auth.getAuthHeader()})
                   .then(function (response) {
     var statusCode =response.data.statusCode,  message = response.data.message;
         if (  statusCode == 200 )
          _this.$message.success(message);                           })
                       .catch(function (error) {
        var statusCode =err.response.data.statusCode,  message = err.response.data.message;
          _this.$message.error(message);      
                      });      
    } else {
                _this.$message.error('Empty Entry! Nothing Change!');      

    }


},
subAttendance(){
     var _this = this;
 
var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
var localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0,-1).substring(0, 19).replace('T', ' ');
   // console.log("classroom", this.classroom_Input, 'class code',this.selectedOptions, 't id', this.teacherAssign.teacher, this.thisTeacher, 'year', year, 'date', localISOTime);
 //var tdate = localISOTime.split(" ");
 var tdate = this.curClassDate;
// console.log( 'localISOTime', localISOTime)
var  newInput =[];
var  updateInput =[];
                        //  console.log('this.getAttendAbsence.lengt      ', this.getAttendAbsence.length);
 
             if (this.getAttendAbsence.length > 0 ) {      // for update 
                 for (var i = 0; i < this.classAttend.length; i++) { 
                  //   console.log('this.classAttend[i].absence',this.classAttend[i].absence,'this.prevClassAttend[i].absence',this.prevClassAttend[i].absence); 
                  if (this.classAttend[i].absence != this.prevClassAttend[i].absence ) {    // absence status change either from previous 
                    //  console.log('update', this.classAttend[i].absence  );
                    if (this.classAttend[i].prev){     // detect this student has been add or update before, so mark as update
/*                     updateInput.push( {id:this.classAttend[i].id,class_id:this.curClassId, student_id:this.classAttend[i].student_id,
                     date:tdate,absence:this.classAttend[i].absence,created:localISOTime});
 */                  updateInput.push( {id:this.classAttend[i].id,absence:this.classAttend[i].absence,created:localISOTime});
                    // console.log('update',updateInput );
                      } else {                           // insert as new
                     newInput.push( {class_id:this.curClassId, student_id:this.classAttend[i].student_id,
                     date:tdate,absence:this.classAttend[i].absence,created:localISOTime});
                      }
                    


                  }
                 }
              } else {      // if nothing from attendance table, then insert everything as new     
                  
            // very first element mark this class has taking attendance where student_id = 0 with the specified class_id.
             // so when retrieve attendance history, this element is the key to identify attendance taking.
                    newInput.push( {class_id:this.curClassId, student_id:0,date:tdate,absence:0,created:localISOTime});
 
            for (var i = 0; i < this.classAttend.length; i++) {                 
              //   this.classAttend.push({student_name:this.titleCase(this.classAttendArr[i].student_name),absence:0,late:0,left:0});
 
                  if (this.classAttend[i].absence != 0 ) {
                     newInput.push( {class_id:this.curClassId, student_id:this.classAttend[i].student_id,
                     date:tdate,absence:this.classAttend[i].absence,created:localISOTime});
                  }
 
               }
              } // else


 
    
    if (newInput.length > 0) {
    //    console.log ('newInput',newInput);


/*             for (var i = 0; i < newInput.length; i++) {   
             console.log( 'newinput', newInput[i]);
            }      */         
//params.entries(newInput);
// console.log('params',params);
    //  NOTE:************* 10/14/17(Fire week in Northbay, many people died and more 6K structures destroyed)
    //  For POST:: Due to limitation of Godaddy PHP 5.6 Webhosting, it keep reporting the warning below and affect the correct response
    //  I need to trick with PUT, but at the server it's actually, INSERT new data into database.
    //   PHP Deprecated:  Automatically populating $HTTP_RAW_POST_DATA is deprecated and will be removed in a future version. To avoid this warning set 'always_populate_raw_post_data' to '-1' in php.ini and use the php://input stream instead. in Unknown on line 0
    //*************************************************** 
   axios.put (this.$API_url +'/addAttendance/'+ 10, newInput,  {headers: auth.getAuthHeader()})
          .then(function (response) {
                      //  _this.$emit('triggerRefresh');
   //  console.log('add atten', response);

             // console.log(response);
             })
             .catch(function (error) {
                 console.log(error);
             });  
    }

    if (updateInput.length > 0) {
   //  console.log ('update ',updateInput);
//var id = updateInput.id;  // just send anything.

   axios.put (this.$API_url +'/udateAttendance/' + 10 , updateInput,
      {headers: auth.getAuthHeader()})
        .then(function (response) {
       //  console.log(response);
                    
        })
            .catch(function (error) {
                console.log(error);
           });  
    }

      setTimeout(()=>{    this.attendActive = false; },500);
              

},
atos(arr) {
    for (var i=0, l=arr.length, s='', c; c = arr[i++];)
        s += String.fromCharCode(
            c > 0xdf && c < 0xf0 && i < l-1
                ? (c & 0xf) << 12 | (arr[i++] & 0x3f) << 6 | arr[i++] & 0x3f
            : c > 0x7f && i < l
                ? (c & 0x1f) << 6 | arr[i++] & 0x3f
            : c
        );
    return s
},
 object_merge(){
	    for (var i=1; i<arguments.length; i++)
	       for (var a in arguments[i])
             arguments[0][a] = arguments[i][a];
       return arguments[0];
 },

doneHistory(){
  this.dialogHistory = false;

},
formatCell(row, col, cellVal){


// don't know why cellVall is treated as char '1' but not as number.
// was working ok on another file.
          if( cellVal != undefined)  {
                switch (cellVal) {
                  case 1:
                     return('ABSENT');
                      break;
                  case 2:
                      return('LATE');
                      break;
                  case 3:
                      return('LEFT');
                      break;
                  case 0:
                      return('P');
                      break; 
                }
            } else {
                    if (this.subDate[col.property] )    // if it match subDate then treat as take roll
                       return('P');
                    else
                       return('X');
             }

 return(cellVal);


},
handleSelect( val) {
console.log('val S', val, 'absence', val.absence);
// , 'val S', val);
if ( val.absence != 1)
        this.$message({
        message: 'Not Absence!!',
        type: 'info'      })

},
SetupEmail() {

  this.dialogTeacherForm = true;
        
},
AttendanceEmail() {
  var _this = this;
      
       
        if (this.multipleSelection.length > 0) {
  /*              for ( var i = 0; i < this.multipleSelection.length; i++) {
                   this.multipleSelection[i].email = this.junkeMail[i%4].email;} */
        
/*            this.teacher_Input = { class_name:this.curClassName, teacher_name: this.teacher_name,
            teacher_cname: this.teacher_info.teacher_cname, email: this.teacher_info.email, date:this.absenceDate };
 */
     //   var tmp = JSON.stringify(this.teacher_Input);

 axios.put (this.$API_url +'/emailAttendance?name=' + this.teacher_name + '&email=' + this.teacher_info.email +
       '&date=' + this.absenceDate + '&cname=' + this.teacher_info.teacher_cname + '&class=' + this.curClassName ,this.multipleSelection, 
      {headers: auth.getAuthHeader()})
        .then(function (response) {
     // _this.legacySystemHTML = response.data;
      console.log( _this.legacySystemHTML);
             _this.$message({
              showClose: true,
        message: response.data,
        type: 'info'      })
           
        })
            .catch(function (err) {
 
      // console.log('xxdxx', err.response);
         if (err.response !== undefined) {
     var statusCode =err.response.data.statusCode,  message = err.response.data.message;
         //   if (  statusCode == 422)
              _this.$message.error(message); 
          
         } else 
     _this.$message.error('Something Went Wrong with Sending Emails!!!'); 
          
           });  
    } else {
                 //  var tmp = 'lxxxx ' + "\n" + 'dog';
         this.$message({
        message: 'No student selected!! No emails send',
        type: 'info'      })
    }

 //   this.teacher_Input.message = 'Hello,' + '\n'  + 'Contra Costa Chinese School would like to notify you that your child' + '\n' + 'Thank you' ;
       
},
PreviewEmail() {

},
EditTeacherCancel() {
                  this.dialogTeacherForm = false;

        },
// edit Teacher
EditTeacher() {
                  this.dialogTeacherForm = false;
               console.log('edit teacher_Input student', this.teacher_Input );

},
handleSelectionChange(val) {
// console.log('val', val);
     // if (val.absence == 0)
         //this.$refs.multipleTable.clearSelection(row);
  // this.$refs.multipleTable.toggleRowSelection();

// Filter out non absence
    this.multipleSelection =[];
          val.forEach(row => {
         if (row.absence !== 1)  
          this.$refs.multipleTable.toggleRowSelection(row);
          });
         this.multipleSelection = val;


 },

DoneOneHist(){
this.dialogOneHist = false;

},
getOneHist(row,column,cell,event) {


// console.log('row',row,'col', column.property,'cell',cell,'event', event);
var trow;
  if(this.subDate[column.property]) {      // check if this date has taking roll then call get attendance, else ignore.
  trow = { date:column.property};
   this.dialogOneHist = true;
    this.getAttendance(trow);
    this.absenceDate = trow.date;
    //console.log('trow', trow);
 } else {

        this.$message({
        message: 'Nothing to show!!',
        type: 'info'
      })
 }
},
getHistory(row) {

 this.checkTimeOut();

    var _this = this;
 // var tdate = this.curClassDate;
  this.$off( 'triggerAttend');
   this.curClassId = row.class_id;
   this.curClassName = row.fullclass;
  //  console.log ('row', row, 'this.curClassName', this.curClassName);
  this.attendHistory = []; 
  this.subDate =[];

              axios.all([

             axios.get( this.$API_url +'/payclassesClasscode?class_id=' + row.class_id
            + '&year=' + _this.selYear , {
                  params: {
                    
                  }, headers: auth.getAuthHeader()
                }) ,
            axios.get( this.$API_url +'/getAbsenceByClassId/' +  row.class_id
            , {
                  params: {
                    
                  }, headers: auth.getAuthHeader()
                })                 
           ]) 
                .then(axios.spread (function (PayClassCode,AttendAbsence) {
              // console.log(response);
           //  _this.classAttendArr = JSON.parse(pako.inflate(PayClassCode.data.data, { to: 'string' }));
           //  _this.classAttendArr = PayClassCode.data;
              _this.classAttendArr =  JSON.parse(_this.atos(pako.ungzip( atob(PayClassCode.data) ) ));
             // _this.classAttendArr = _this.atos(pako.ungzip( atob(PayClassCode.data)  ) );
           //  console.log(_this.classAttendArr)
             _this.getAttendAbsence = AttendAbsence.data;
           // console.log(_this.getAttendAbsence)
                       _this.$emit('triggerAttend');
                }))
                  .catch(function (error) {
                 console.log(error);
                       _this.$message({
          showClose: true,
          message: 'Login Session Expired!! Please Login Again!',
          type: 'warning',
          duration: 5000,           
        });   
             });    
             
           this.$on( 'triggerAttend' ,function ()  {   
       //  console.log('dogxxx  ', this.curClassName);

       var histList=[], histDate=[]; var i,j, tmpdate, tmpvar; var tmpobj={};  var mobj;   var result, atdate ={};      
                 //   console.log(' befero history', i , 'mobj', mobj,'histList', histList);
           if (this.getAttendAbsence.length > 0)   {      // detect this class has been taking role, then find all student_id 
               for ( i = 0; i < this.getAttendAbsence.length; i++) {
                 if ( this.getAttendAbsence[i].student_id == 0) {          // get all the dates that has been taking attendance with this Class id
                 tmpdate =  this.getAttendAbsence[i].date.split("T");
                   // histDate.push({date:this.getAttendAbsence[i].date});
                    this.subDate[tmpdate[0]] = true;
                 }
               }
 // console.log('subDate', this.subDate, 'length',this.subDate.length);
          // for ( j = 0; j < histDate.length; j++) { 
                     //    tmpdate =  histDate[j].date.split("T"); tmpvar = tmpdate[0]; atdate[tmpvar] = 0;
                    
               for ( i = 0; i < this.classAttendArr.length; i++) {

                      tmpvar = this.classAttendArr[i].student_id;
                   //   tdate = histDate[j].date;
                     // console.log ('tdate', tdate);
                //    console.log('this.classAttendArr[i].student_id', tmpvar)
                     let result1 =  this.getAttendAbsence.filter(function (el) {     // get all date with one student
                                  return (el.student_id === tmpvar);});

                  //   console.log('result1',result1)       
                             //result = ;


                      if ( result1.length > 0) {     // if not found, set attended 
                      mobj= {};    tmpobj ={};                                                     
                         for ( j = 0; j < result1.length; j++) { 
                        tmpdate =  result1[j].date.split("T"); tmpvar = tmpdate[0];
                         tmpobj[tmpvar] = result1[j].absence;     // don't know why?? this accumulate. just like push in array.

 /*                         if(!isNaN(result1[j].absence))
                           console.log('tmpobj', 'result1[j].absence', result1[j])
 */                            }
                           //    console.log('result',result, 'result date', result.date)
                      //  tmpdate =  result.date.split("T"); tmpvar = tmpdate[0]; tmpobj[tmpvar] = result.absence;

                      mobj= this.object_merge({},{student_name:this.titleCase(this.classAttendArr[i].student_name)}, tmpobj); 
                       histList.push(mobj)
                  //  console.log('history', i , 'mobj', mobj,'histList' , histList);
                       // histList.push(tmpvar)
                      } else {
                    //  tmpdate =  histDate[j].date.split("T"); tmpvar = tmpdate[0]; atdate[tmpvar] = 0;
                         // mobj= this.object_merge({},{student_name:this.titleCase(this.classAttendArr[i].student_name)} ); 
                       histList.push({student_name:this.titleCase(this.classAttendArr[i].student_name)});
                      }
               }
        //   }   // j for 
           }

     // console.log('histList', histList);
     this.DialogInfo = 'Attendance History for Class : ' + this.curClassName + '  ::::: P = Present , X = Attendance not taken or not yet taken';
  this.attendHistory = histList;
  this.dialogHistory = true;






}); //trigger

},

DoneDialogClassCode() {
    this.dialogClassCode = false;
},

detailClass(row){

   this.getDetail = row;

     var _this = this;
      var tdate;
  
  this.dialogClassCode = true;

          this.curClassId = row.class_id;
           this.curClassName = row.fullclass;
           tdate = this.curClassDate;

 // setTimeout(()=>{ this.checkTimeOut() },10000);

     
    
  this.$off( 'triggerAttend');
    //     if (  this.curClassDateActive    ||  this.dialogOneHist ) {  // allow only in active school date or just view history

this.checkTimeOut();


              axios.all([

             axios.get( this.$API_url +'/payclassesClasscode?class_id=' + this.curClassId
            + '&year=' + _this.selYear , {
                  params: {
                    
                  }, headers: auth.getAuthHeader()
                }) ,
            axios.get( this.$API_url +'/getAbsenceByClassIdDate?class_id=' +  this.curClassId
            + '&date=' + tdate , {
                  params: {
                    
                  }, headers: auth.getAuthHeader()
                })                 
           ]) 
                .then(axios.spread (function (PayClassCode,AttendAbsence) {
              // console.log(response);
           //  _this.classAttendArr = JSON.parse(pako.inflate(PayClassCode.data.data, { to: 'string' }));
              _this.classAttendArr =  JSON.parse(_this.atos(pako.ungzip( atob(PayClassCode.data) ) ));
      //  console.log(_this.classAttendArr)
            // _this.classAttendArr = PayClassCode.data;
             _this.getAttendAbsence = AttendAbsence.data;
       //  console.log('kkk',_this.getAttendAbsence)
                       _this.$emit('triggerAttend');
                }))
                  .catch(function (error) {
                 console.log(error);
             });    
             
           this.$on( 'triggerAttend' ,function ()  {
       
       //   this.handleDownload('pdf',) 
      
      }); //trigger
     
     
   
  
           
                
},
handleDownload(pdf) {
      var list = [];
      var i;
     // var tmp = this.displayClassArr;
      

 
     list = this.classAttendArr;

   //  console.log('list', list);

      var selYear = this.selYear;
      var ymargin = 50;
      var noteText ='';
      var fullclass = this.getDetail.fullclass ;
      
      var title =  this.getDetail.fullclass + ' : ' + this.getDetail.title;
      var chinese_title = this.getDetail.chinese_title;
      var cteacher =  this.teacher_info.teacher_cname;

      //  + ' (' +  this.teacher_info.teacher_cname + ')'
      
      var teacher = this.teacher_name ,classroom = this.getDetail.classroom ,total = list.length;
      //console.log('this.getDetail', this.getDetail);
 
     if (pdf === 'pdf' || pdf == 'post' || pdf === 'pdfFirst'  ) {

       if (pdf === 'post')
        var doc = new jsPDF('p');// portrait for post
        else
        var doc = new jsPDF('l'); 
  
       var teachDat = [

            {header:'Class  : '+  title},
           {header:'Teacher  : '+ teacher },
           {header:'Classroom : '+ classroom  + ' ,  Number of Students : ' + total}

        ]

          if (pdf == 'post' ) {          // post only list student name
             var getColumns = 
               [
               {title: "Students", dataKey: "student_name"},  {title: "Parents", dataKey: "parent_name"},
               {title: "Email", dataKey: "email"}, {title: "Phone", dataKey: "phone"} ,  
                                ];
          
          
          } else {
             
              var getColumns = 
               [
               {title: "Students", dataKey: "student_name"},  {title: "Parents", dataKey: "parent_name"},
                {title: "Phone", dataKey: "phone"} ,  {title: "EC Person", dataKey: "ecp_name"} , 
                {title: "EC Phone", dataKey: "ecp_phone"},    {title: "Medical Condition", dataKey: "medical_cond"} , 
                {title: "Allergy", dataKey: "allergy"},     {title: "Dr. Name", dataKey: "doctor_name"} , 
                {title: "Dr. Phone", dataKey: "doctor_phone"},  {title: "Medical Insurance", dataKey: "ins_company"},  
                {title: "Insurance #", dataKey: "ins_policy"},  
                ];
          }

 
        var headColumns = [
                   {title: "Header", dataKey: "header"},
                //  {title: "Data", dataKey: "data"}               

        ]

 // for header
// console.log(doc.getFontList());


// add page number 
    var totalPagesExp = "{total_pages_count_string}";

   var pageContent = function (data) {
     

        // FOOTER
        var str = "Page " + data.pageCount;
        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === 'function') {
            str = str + " of " + totalPagesExp + '  --- Year: ' +  selYear + ', '   +   title;
        }
        doc.setFontSize(10);
        doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
    };
    


 doc.autoTable(headColumns, teachDat, {
        showHeader: 'never',
       // tableWidth: 'wrap',
      //  margin: {horizontal: 7},    
              styles: {cellPadding: 1, fontSize: 12},

          columnStyles: {
            //header: {fillColor: [204, 255, 221], textColor: 0, font: 'courier', fontStyle: 'bold'}
            header: { font: 'Times', fontStyle: 'bold'}
        }
        });


   // doc.text('Theme "grid"', 14, doc.autoTable.previous.finalY + 10);


 // table content       
      doc.autoTable(getColumns, list,
      {
         addPageContent: pageContent ,
   
        theme: 'grid',
        margin: {horizontal: 10}, 
        startY: ymargin,

       
  styles: { fontSize: 10, overflow: 'linebreak',columnWidth: 'auto', minCellWidth : 'wrap' },
   columnStyles: {medical_cond: {columnWidth: 20}, 
    ins_company: {columnWidth: 20},
    allergy: {columnWidth: 25},
    doctor_name: {columnWidth: 25},
    ins_policy: {columnWidth: 20},
    phone: {columnWidth: 18},
    ecp_phone: {columnWidth: 18},
    doctor_phone: {columnWidth: 18}
    }

    
     //  overflowColumns: false
      
      }
    /*   {
        startY: 50,
        margin: {horizontal: 7},
        overflowColumns: false,
    //  styles: {cellPadding: 1, fontSize: 10, columnWidth: 'wrap'},
      styles: {cellPadding: 1, fontSize: 10, columnWidth: 20},
        columnStyles: {text: {columnWidth: 'auto'}}    } */
    );

  

 // add page number 
if (typeof doc.putTotalPages === 'function') {
        doc.putTotalPages(totalPagesExp);
    }

 
    doc.save(fullclass + '-Year' + selYear);
    
     }     
   else {       // export to excel
//console.log('xxxx',title,teacher,phone,classroom);

        const tyear = [ "Year", selYear, '','','','','','']; 
        const tclass = [ "Class (課程)", title, chinese_title,'','','','','']; 
        const tteacher = [ "Teacher (授課老師)", teacher + '(' + cteacher + ')', '','','','','','','']; 
      //  const tphone = [ "Phone  (電話)", phone, '','','','','','']; 
        const tclassroom = [ "Classroom (教室)", classroom, '','','','','','']; 
        const tempty = [ "", '', '','','','','','']; 
        const ttotal = [ "Total", total, '','','','','','']; 

    if (pdf == 'cp') {

      require.ensure([], () => {
        const { my_export_json_to_excel } = require('utils/Export2Excel');
 /*       const tHeader = ["Students", "Parents",'Email', 'Phone', 'EC Person','EC Phone'];
        const filterVal = [ 'student_name', 'parent_name', 'email','phone','ecp_name','ecp_phone']; 
  */     
  
  const tHeader = ["Students", '中文名字', "Parents",'Email', 'Phone'];
        const filterVal = [ 'student_name', 'chinese_name', 'parent_name', 'email','phone'];  

        var data = this.formatJson(filterVal, list);
        // add class/teacher header 
        data.unshift(tHeader);data.unshift(tempty);data.unshift(tclassroom); 
        //data.unshift(tphone); 
         data.unshift(tteacher);
        data.unshift(tclass);  data.unshift(tyear);
        // add total
        data.push(tempty); data.push(ttotal);

   // console.log('xxxx',data);

        my_export_json_to_excel( data, fullclass + '-Year' + selYear, true); // just grab 1st array's title. they are all the same.

      })
    } else {


      require.ensure([], () => {
        const { my_export_json_to_excel } = require('utils/Export2Excel');
 
      const tHeader = ["Students", '中文名字', "Parents",'Email', 'Phone', 'EC Person','EC Phone', 'Medical Condition','Allergy',"Dr. Name",
         "Dr. Phone", "Medical Insurance","Insurance #"];
        const filterVal = [ 'student_name', 'chinese_name', 'parent_name', 'email','phone','ecp_name','ecp_phone','medical_cond','allergy','doctor_name', 
        'doctor_phone','ins_company', 'ins_policy'];  
 
        var data = this.formatJson(filterVal, list);
        // add class/teacher header 
        data.unshift(tHeader);data.unshift(tempty);data.unshift(tclassroom); 
        //data.unshift(tphone); 
         data.unshift(tteacher);
        data.unshift(tclass);  data.unshift(tyear);
        // add total
        data.push(tempty); data.push(ttotal);

   // console.log('xxxx',data);

        my_export_json_to_excel( data, fullclass + '-Year' + selYear); // just grab 1st array's title. they are all the same.

      })
    }
     }

    },

 formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
  
getAttendance(row){
     var _this = this;
      var tdate;
  

 // setTimeout(()=>{ this.checkTimeOut() },10000);

     if (!this.dialogOneHist) {
          this.curClassId = row.class_id;
           this.curClassName = row.fullclass;
           tdate = this.curClassDate;
     } else {
     //   console.log('dogxx1', row.date);
      tdate = row.date;
 
     }
    
  this.$off( 'triggerAttend');
    //     if (  this.curClassDateActive    ||  this.dialogOneHist ) {  // allow only in active school date or just view history

this.checkTimeOut();


              axios.all([

             axios.get( this.$API_url +'/payclassesClasscode?class_id=' + this.curClassId
            + '&year=' + _this.selYear , {
                  params: {
                    
                  }, headers: auth.getAuthHeader()
                }) ,
            axios.get( this.$API_url +'/getAbsenceByClassIdDate?class_id=' +  this.curClassId
            + '&date=' + tdate , {
                  params: {
                    
                  }, headers: auth.getAuthHeader()
                })                 
           ]) 
                .then(axios.spread (function (PayClassCode,AttendAbsence) {
              // console.log(response);
           //  _this.classAttendArr = JSON.parse(pako.inflate(PayClassCode.data.data, { to: 'string' }));
              _this.classAttendArr =  JSON.parse(_this.atos(pako.ungzip( atob(PayClassCode.data) ) ));
      //  console.log(_this.classAttendArr)
            // _this.classAttendArr = PayClassCode.data;
             _this.getAttendAbsence = AttendAbsence.data;
       //  console.log('kkk',_this.getAttendAbsence)
                       _this.$emit('triggerAttend');
                }))
                  .catch(function (error) {
                 console.log(error);
             });    
             
           this.$on( 'triggerAttend' ,function ()  {
       /*    if (  !this.curClassDateActive  && !this.dialogOneHist ) { 
                 //  this.attendActive = true;
     this.$message({
        message: 'Sorry! Today is not class date! Next class date is ' + this.nextClassDate,
        type: 'warning'
      }) }   */
          this.processjunk() 
      
      }); //trigger
     
     
   
  
           
                
},
processjunk()
{
   if (!this.dialogOneHist )
       this.attendActive = true;

  //console.log('in process junk')

     var _this = this;
     var list =[];
   this.classAttend = [];
   this.prevClassAttend =[];
   this.curAbsenceCnt =0;
   this.curLateCnt =0;
   this.curLeftCnt =0;
   this.curAttendCnt =0;
      var histList=[];
  var cname='';
  var tmp='';
  var notcname=false;

           if (_this.getAttendAbsence.length > 0)   {      // detect this class has been update, then find all student_id 
                  this.newAttend = ' Updated ';

                    
              for (var i = 0; i < this.classAttendArr.length; i++) {

                    // check chinese name
                        notcname=false;
                        cname=  this.classAttendArr[i].chinese_name;  
                        tmp=  this.classAttendArr[i].chinese_name.replace(/ /g,'');  
                     // if(   /^[a-z][a-z\d]*$/i.test(tmp))  notcname = true;
                      if(  !tmp.toString().match(/[\u3400-\u9FBF]/) && tmp != '')        // detect if chinese name
                         notcname = true;
                                                   

                   let result =  this.getAttendAbsence.find( x => x.student_id === this.classAttendArr[i].student_id );
                   //  console.log('resu',result)
                      if ( result === undefined) {     // if not found, set attended    
                         this.classAttend.push({student_name:this.titleCase(this.classAttendArr[i].student_name),absence:0,
                     chinese_name:cname,notcname:notcname, email : this.classAttendArr[i].email,  student_id:this.classAttendArr[i].student_id,prev:false,id:0});
                       this.prevClassAttend.push({student_name:this.titleCase(this.classAttendArr[i].student_name),absence:0,
                        student_id:this.classAttendArr[i].student_id,prev:false,id:0});
                              this.curAttendCnt++;
                    } else {
                                         //   console.log('undefine x',this.classAttendArr[i] )  ;                                                    

                         this.classAttend.push({student_name:this.titleCase(this.classAttendArr[i].student_name),absence:result.absence,
                       chinese_name:cname,notcname:notcname, email:this.classAttendArr[i].email, student_id:this.classAttendArr[i].student_id,prev:true,id:result.id});                        
                       this.prevClassAttend.push({student_name:this.titleCase(this.classAttendArr[i].student_name),absence:result.absence,
                        student_id:this.classAttendArr[i].student_id,prev:true,id:result.id});     
                          
 /*                         if( Number.isFinite(result.absence) )
                         console.log('integer', result);
                         else                          console.log('not integer', result);
 */
                        switch (result.absence) {
                          case 1:
                              this.curAbsenceCnt++;
                              break;
                          case 2:
                              this.curLateCnt++;
                              break;
                          case 3:
                              this.curLeftCnt++;
                              break;
                          case 0:
                              this.curAttendCnt++;
                              break; 
                          }                                          
                     }
               }

               } else {
                 this.newAttend = ' New ';

                  for (var i = 0; i < this.classAttendArr.length; i++) {

                    // check chinese name
                        notcname=false;
                        cname=  this.classAttendArr[i].chinese_name;  
                        tmp=  this.classAttendArr[i].chinese_name.replace(/ /g,'');  
                      if(  !tmp.toString().match(/[\u3400-\u9FBF]/) && tmp != '')        // detect if chinese name
                      notcname = true;
                                                      
                         this.classAttend.push({student_name:this.titleCase(this.classAttendArr[i].student_name),absence:0,
                      chinese_name:cname, notcname:notcname,  email:this.classAttendArr[i].email, student_id:this.classAttendArr[i].student_id,prev:false,id:0});
                        this.prevClassAttend.push({student_name:this.titleCase(this.classAttendArr[i].student_name),absence:0,
                        student_id:this.classAttendArr[i].student_id,prev:false,id:0});
                              this.curAttendCnt++;
               }
                 
               }
/* 
   if ( !this.attendActive) {
    this.prevClassAttend = this.classAttend; // remember class attendance before any changes. didn't work bug!! maybe build as link list 
    console.log('xxxxxx')
   } */
   
this.displayAbsence = 'Absent  (' + this.curAbsenceCnt + ')';
this.displayAttended = 'Present (' + this.curAttendCnt + ')';
this.displayLate = 'Late   (' + this.curLateCnt + ')';
this.displayLeft = 'Leave Early (' + this.curLeftCnt + ')';


//    this.displayInfo  = 'Teacher : '+ this.teacher_name + ' ,  Class : ' +  this.curClassName  + ' , Number of Students : ' +   this.classAttendArr.length;      
    this.displayInfo  = '   Class : ' +  this.curClassName  + ' , Number of Students : ' +   this.classAttendArr.length;      
                              
},
changeStatus (index,row,status) {
// console.log('before',index, row, status)

            if ( this.classAttend[index].absence != status )  {    // detect status changes
 
                 switch (status) {
                  case 1:
                      this.curAbsenceCnt++;
                      break;
                  case 2:
                      this.curLateCnt++;
                      break;
                  case 3:
                      this.curLeftCnt++;
                      break;
                  case 0:
                      this.curAttendCnt++;
                      break; 
                  } 
                  
                 switch (this.classAttend[index].absence) {    // deduct count from previous absence
                  case 1:
                      this.curAbsenceCnt--;
                      break;
                  case 2:
                      this.curLateCnt--;
                      break;
                  case 3:
                      this.curLeftCnt--;
                      break;
                  case 0:
                      this.curAttendCnt--;
                      break; 
                  } 
                      this.classAttend[index].absence = status;
 
                }     // if                                    

   
this.displayAbsence = 'Absent  (' + this.curAbsenceCnt + ')';
this.displayAttended = 'Present (' + this.curAttendCnt + ')';
this.displayLate = 'Late   (' + this.curLateCnt + ')';
this.displayLeft = 'Leave Early (' + this.curLeftCnt + ')';

 //  console.log('this.classAttend[index].absence',  this.classAttend[index].absence, 'this.prevClassAttend[index].absence',this.prevClassAttend[index].absence)

},

processCategory ()
{
     var _this = this;
    _this.teacherArr =[];
    _this.classArr =[];
   // _this.classOptions =[];
      var i, j;
 
 // this.tmpFullname = _this.teacherList[0].fullname;
 j=1;
var cat ={};
var code =[];
var opt =[];
var mapMonth =[];
         mapMonth['01']= 'JAN';
         mapMonth['02']= 'FEB'; mapMonth['03']='MAR'; mapMonth['04']='APR';mapMonth['05']= 'MAY'; mapMonth['06']='JUN'; 
         mapMonth['07']='JUL'; mapMonth['08']='AUG'; mapMonth['09']='SEP'; mapMonth['10']= 'OCT'; mapMonth['11']= 'NOV'; mapMonth['12']= 'DEC';

            this.$off( 'triggerLoad');
            var tmpdate1, tmpdate, month, day;
            var d = new Date();
              
 //console.log('this.attendDatesArr', this.attendDatesArr);
          this.cols =[];
            //    this.cols.push( {prop:'student_name', label:'Students', width:150 });
var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
var localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0,-1).substring(0, 19).replace('T', ' ');
 var today =  localISOTime.split(' ');     var prevWeek, nextWeek;                  
 
        this.curClassDate ='';
       this.curClassDateActive = false;
var year;
       for (i = 0; i < this.attendDatesArr.length; i++) {    
               tmpdate =   this.attendDatesArr[i].date.split("T");
                 tmpdate1 = tmpdate[0].split("-");
                 year =tmpdate1[0];
                 month = tmpdate1[1];
                 day = tmpdate1[2];
       //   console.log('tmpdate', tmpdate[0], 'xx', tmpdate[1], tmpdate[2],this.attendDatesArr[i] );
             
//console.log ('month', month, 'map', mapMonth[month]); , formatCell(){return 'x'}

             //  today[0]='2018-09-29';  //for testing purpose

                 if (tmpdate[0] == today[0]) {
                    this.curClassDate = tmpdate[0];      // set curDate active to take roll
                    this.curClassDateActive = true;
                 }
                   
                  

                 if (tmpdate[0] <= today[0]) {
                    this.cols.push( {prop:tmpdate[0], label:'## ' + year + ' #' + mapMonth[month] + '-' + day, width:100});
 
                 }
                  else if (i < this.attendDatesArr.length-1) {         // if greater than today then display one more and out
                     this.nextClassDate = tmpdate[0];
 //                    this.cols.push( {prop:tmpdate[0], label:'## ' + year + ' #' + mapMonth[month] + '-' + day, width:100});
                    break;
                  }
                   
                
               }  // for
          if(this.curClassDateActive )
             this.displaySchoolDate = ' Attendance Sheet for Class Date : ' + this.curClassDate ;
          else
             this.displaySchoolDate = ' Today is not Class Date : ' + today[0] + '    :::  Next Class Date is  ' + this.nextClassDate;


//  this.disCols = Object.assign({}, this.cols);       // copied array.
          this.disCols = [];                    

// copy and only display the last 7 school dates
   var tbegin = 0;
        if (this.cols.length > 6) {
          tbegin = this.cols.length -7;
        }
       for (i = this.cols.length-1; i >= tbegin; i--)    // display only the last 7
             this.disCols.push(this.cols[i]);    // if greater than today then display one more and out

 // console.log(' cols ', this.disCols);

 
/* 
               for (i = 0; i < this.teacherList.length; i++) { 
             
                if (_this.teacherList[i].fullname !== this.tmpFullname) {
                        j++;       // incr j for next teacher
                  } 
                  _this.teacherArr.push({value :_this.teacherList[i].teacher_id , label:_this.teacherList[i].fullname});
               } 
 */
  
// console.log ('teachers ', _this.teacherArr);

  /*             for (i = 0; i < this.classList.length; i++) { 
            
 
                   if ( cat[ _this.classList[i].category] !== _this.classList[i].category &&   _this.classList[i].category !== 'V') {
                     cat [ _this.classList[i].category] = _this.classList[i].category;
                   }
                   if ( cat[ _this.classList[i].category] === _this.classList[i].category) {
                     code[ _this.classList[i].class_id] = _this.classList[i].class_code + ' ' + _this.classList[i].title;
                   }
                     

               } */ // for

  // console.log('cat legn', Object.keys(cat).length);
 /*               for (var k in cat) {
    if (cat.hasOwnProperty(k)) {
       // console.log ('key is: ' + k + ' kk', cat.hasOwnProperty(k), ', value is: ' + cat[k]);
    }
} 
 
                  for (var k in cat)  { 
                    // create class code belong to each category
                    code = [];
                      for (i = 0; i < this.classList.length; i++) { 
                   if ( cat[k] === _this.classList[i].category) {
                   code.push( {label: _this.classList[i].class_code + ' ' + _this.classList[i].title, value:_this.classList[i].class_id })
                   }
                                  }
                             //     console.log ( 'code ', code)
 
               opt.push( { value: cat[k], label: cat[k], children:code});
               }
 */
     //   this.classOptions = opt;

   

 /*                   console.log ('volun code before', _this.teacherArr);

                    _this.teacherArr.sort(function(a,b){  var alc = a.label.toLowerCase(), blc = b.label.toLowerCase();
                    return alc > blc ? 1 : alc < blc ? -1 : a.label > b.label ? 1 : a.label < b.label ? -1 : 0;});
                     console.log ('volun code after', _this.teacherArr); */

},

     // search family with names
            loadList () {
              
                
          //  console.log( " dog 初始化加载数据开始...");
                var _this = this;
                var i, j;
           //   _this.loading = true;
           
       if( this.teacher.authenticated) {

           axios.all([
          
             axios.get( this.$API_url +'/getTeacherClasses?teacher_id=' + _this.teacher_id
            + '&year=' + _this.selYear , {
                  params: {
                    
                  }, headers: auth.getAuthHeader()
                }),
           
               axios.get( this.$API_url +'/attend_dates/' + _this.selYear, {
                  params: {
                    
                  },headers: auth.getAuthHeader()
                }),
              axios.get( this.$API_url +'/classcode/' + _this.selYear, {
                  params: {
                    
                  },headers: auth.getAuthHeader()
                })
 /*             axios.get( this.$API_url +'/payclassesClasscode?class_id=' + 133
            + '&year=' + _this.selYear , {
                  params: {
                    
                  }, headers: auth.getAuthHeader()
                })    */           
            ]) 
                .then(axios.spread (function (TeacherClass,attendDates,ClassCode) {

             //   _this.loading = false;
               //   _this.teacherClassesArr = TeacherClass.data;
                _this.teacherClassesArr = JSON.parse(_this.atos(pako.ungzip( atob(TeacherClass.data)  ) ) );
               //   console.log('teacherClassesArr', _this.teacherClassesArr);

               //   _this.teacherList = JSON.parse(pako.inflate(teachNames.data.data, { to: 'string' }));
                  _this.attendDatesArr = attendDates.data;
                //  console.log( _this.attendDatesArr);
                  _this.classList = ClassCode.data;
               //   _this.classAttendArr = JSON.parse(pako.inflate(ClassAttend.data.data, { to: 'string' }));
                       _this.$emit('triggerLoad');

                }))
                .catch(function (error) {
                    _this.$message.error('Login Expired!! Please logout and login again');      
                  
               //   console.log(error);
                });
          
               this.$on( 'triggerLoad' ,function ()  {  this.processCategory() });

               // hash
           //   var a = new Array(); // or just []

       } // if

            },
// css related      
      tableRowClassName(row,index) {


 // console.log('in row', j, row.teacher_id);
         
//        if (index === 1) {

        if ( (row.teacher_id %4) === 0 ) {
       //  this.tmpFullname =  row.fullname;
       //    console.log('x in row', row.fullname);
         return 'info-row';
     } else    if ( (row.teacher_id %3) === 0 ) {
          return 'positive-row';
     } else  {
     //      console.log('y in row', row.fullname);
     //   this.tmpFullname =  row.fullname;
      //   this.tmpFullname =  row.fullname;
        }
        return '';
      }

        }, // method
   beforeRouteEnter (to, from, next )  {
   
  // window.location.reload(true); 

       next(vm => {
    
    if (!vm.teacher.authenticated)        // if not teacher login back to home.
        vm.$router.push({path: '/'});
        }) 

 //if (!this.donecat)  this.reload =  setInterval(() => { this.loadList(); }, 5000);

 }   //before
      
         
    }

</script>

<style>
.link-type,
.link-type:focus {
  color: #337ab7;
  cursor: pointer;
    font:  bold 16px Times, serif;
  
}
.link-small,
.link-small:focus {
  color: #337ab7;
  background: #ffff99;
   font:  bold 12px Times, serif;
  cursor: pointer;
  
}
.app-container {
  padding: 30px;
}
.el-table-column .info-col {
    background: #ffff99;
  }

.el-table .info-row {
    background: #ffff99;
  }

  .el-table .positive-row {
    background: #ccffcc;
  }

.demo-table-expand {
   font-size: 0;
}

.bigbolds {
    font:  bold 24px Times, serif;
}
.notcname {
    width:100px; background: lightyellow; font:  bold 12px Times, serif;
}
.small {
    width:100px; background: #e6ffe6; font:  bold 12px Times, serif;
}

.bolds {
    font:  bold 16px Times, serif;
}
.demo-table-expand label {
    width: 10px;
    color: #99a9bf;
}
.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
}
  button{
    display: block;
    margin: 0 auto;
    line-height: 30px;
    border: 1px solid #ddd;
    color: #41b883;
  }
  a{
    color: #35495e;
    font-size: 16px;
  }
  ul{
    margin-bottom: 60px;
  }
  li{
    line-height: 32px;
    border-bottom: 1px solid #ddd;
    padding: 0 10px;
  }
  b{
    font-size: 12px;
    color: #35495e;
  }
  .loading{
    text-align: center;
  }
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }

</style>



// WEBPACK FOOTER //
// attendance.vue?949d9ed8